import * as React from 'react'
import * as Styles from './LoadingStyle'

export class Loading extends React.Component {
    public render() {
        return (
            <div className={Styles.WKloadMoreWrap}>
                <i className={Styles.WKloadMore}/>
            </div>
        )
    }
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.tsx